import React, { useState } from 'react';
import styled from 'styled-components';
import { useTheme } from '../context/ThemeContext';

const sizeMap = {
  xs: 24,
  sm: 28,
  md: 36,
  lg: 80,
};

const fontSizeMap = {
  xs: '10px',
  sm: '11px',
  md: '14px',
  lg: '24px',
};

const AvatarContainer = styled.div`
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${props => props.$size >= 36 ? `0 2px 8px ${props.theme.colors.tint}40` : 'none'};
`;

const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
`;

const InitialsAvatar = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, ${props => props.theme.colors.tint}, ${props => props.theme.colors.primary});
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: ${props => props.$fontSize};
`;

const getInitials = (name) => {
  if (!name) return 'U';
  return name
    .split(' ')
    .map(word => word[0])
    .filter(Boolean)
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

export const Avatar = ({ src, name, size = 'md' }) => {
  const theme = useTheme();
  const [imgError, setImgError] = useState(false);

  const px = sizeMap[size] || sizeMap.md;
  const fontSize = fontSizeMap[size] || fontSizeMap.md;

  const showImage = src && !imgError;

  return (
    <AvatarContainer theme={theme} $size={px}>
      {showImage ? (
        <AvatarImage
          src={src}
          alt={name || 'User avatar'}
          onError={() => setImgError(true)}
          referrerPolicy="no-referrer"
        />
      ) : (
        <InitialsAvatar theme={theme} $fontSize={fontSize}>
          {getInitials(name)}
        </InitialsAvatar>
      )}
    </AvatarContainer>
  );
};
